// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"368":"652528c9","787":"7bc64cd3"}[chunkId] + ".chunk.js";
};